import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { BulletItem } from "./Item";
var BulletList = function(param) {
    var items = param.items, type = param.type;
    return /*#__PURE__*/ _jsx("ul", {
        children: items.map(function(item, index) {
            return /*#__PURE__*/ _jsx(BulletItem, {
                item: item,
                type: type || "checkmark"
            }, "bullet-item-".concat(index));
        })
    });
};
export { BulletList };
